import React from 'react';
import { FaArrowLeft } from "react-icons/fa6";

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-9xl font-extrabold text-gray-800">404</h1>
        
        <div className="w-full h-1 bg-blue-500 my-6"></div>
        
        <h2 className="text-2xl font-bold text-gray-700 mb-4">Page Not Found</h2>
        
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => window.history.back()} 
            className="flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium text-blue-600 bg-white border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
          >
            <FaArrowLeft size={16} />
            Go Back
          </button>
          
          <a 
            href="/" 
            className="px-6 py-3 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Return Home
          </a>
        </div>
      </div>

      <div className="mt-16 text-gray-400 text-sm">
        <p>© {new Date().getFullYear()} Turning Ideas Ventures. All rights reserved.</p>
      </div>
    </div>
  );
};

export default NotFoundPage;